import { createQueryKeys } from "@lukemorales/query-key-factory";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { State } from "@models/State";
import client, { RequestParams } from "@services/api";
import { QueryOptions } from "@utils/reactQuery";

export const statesKeyFactory = createQueryKeys("states", {
  list: (params) => ({
    queryKey: [params],
    queryFn: () =>
      client.get<State[]>("states", { params }).then((res) => res.data),
  }),
});

export const useStatesQuery = <TData = State[]>(
  params?: RequestParams,
  config?: QueryOptions<State[], TData>
) => {
  return useQuery({
    ...statesKeyFactory.list(params),
    staleTime: Infinity,
    ...config,
  });
};

type UpdateStateEmailsPayload = Pick<
  State,
  "id" | "couponPriorApprovalEmail" | "priorApprovalEmail"
>;

export const useUpdateStateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, ...data }: UpdateStateEmailsPayload) =>
      client
        .patch<State>(`states/${id}`, {
          ...data,
          __type: "state",
        })
        .then((res) => res.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: statesKeyFactory._def });
    },
  });
};
